var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReActivateUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-4 text-gray-500 hover:text-gray-700 cursor-pointer m-auto",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#676767",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m850 625c-124.27 0-225 100.73-225 225s100.73 225 225 225 225-100.73 225-225-100.73-225-225-225zm-275 225c0-151.88 123.12-275 275-275s275 123.12 275 275-123.12 275-275 275-275-123.12-275-275z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m832.03 902.14 110.12-154.18 40.688 29.062-125 175c-3.9141 5.4727-9.8672 9.1445-16.52 10.172-6.6523 1.0312-13.438-0.66797-18.824-4.7031l-100-75 30-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m500 125c-110.46 0-200 89.543-200 200s89.543 200 200 200c110.45 0 200-89.543 200-200s-89.547-200-200-200zm-250 200c0-138.07 111.93-250 250-250s250 111.93 250 250-111.93 250-250 250-250-111.93-250-250z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m500 575c-207.11 0-375 167.89-375 375h-50c0-234.72 190.28-425 425-425z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReActivateUser);
export default __webpack_public_path__ + "static/media/re-activate-user.e4fb144f61e9228c570db3ca1fbe5186.svg";
export { ForwardRef as ReactComponent };